import React, {useMemo} from "react";
import AdminLayout from "@widgets/layout/AdminLayout";
import router, {Route} from "@/routing/Router";
import EmployeesTimesheet from "@widgets/reports/timesheet/EmployeesTimesheet";

const Timesheet = () => {
    const route: Route = useMemo(() => router.timesheet, []);

    return (
        <AdminLayout currentPage={route}>
            <EmployeesTimesheet route={route}/>
        </AdminLayout>
    );
};

export default Timesheet;